module.exports = __webpack_public_path__ + "static/media/pousada_5.9c7c8e3a.jpg";